import React from "react";
import { SelectAntd } from "./styles";

export default function AntdSelect({ ...props }) {
	return <SelectAntd {...props} />;
}
